


























import { defineComponent } from '@vue/composition-api'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(faTimes)

export default defineComponent({
  props: {
    modal: Boolean
  },
  setup(_, { emit }) {
    const closeModal = () => emit('modal-closed')

    return {
      closeModal
    }
  }
})
